import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, Inject} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../../../../../../utils/utils';

interface MGMTBranchNode {
    groupId: string;
    groupName: string;
    subGroupsAllowed: boolean,
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: MGMTBranchNode;
    groups: MGMTBranchNode[];
    groupFunction: string;
    isSelectable?: boolean;
}

@Component({
    selector: 'osh-assignbranchpopup',
    templateUrl: './assignbranchpopup.component.html',
    styleUrls: ['./assignbranchpopup.component.less',
        '../../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class OshAssignBranchPopupComponent {

    public TREE_DATA: MGMTBranchNode[] = [];

    public treeControl: NestedTreeControl<MGMTBranchNode>;
    public dataSource = new MatTreeNestedDataSource<MGMTBranchNode>();

    public showOnlySelected = false;
    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    public form: FormGroup;

    isCallSucceed: number = 0;
    isMerged = false;
    ngSelectItems: any;
    selectedBranches: string[] = [];
    selectAllCheckbox = false;
    manualItemSelected = false;
    public searchString: string = '';
    
    constructor(fb: FormBuilder,
        private readonly route: ActivatedRoute,
        private readonly http: HttpClient,
        public dialogRef: MatDialogRef<OshAssignBranchPopupComponent>,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly toastrService: ToastrService,

    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.resetAll();
            });
        this.treeControl = new NestedTreeControl<MGMTBranchNode>((node) => node.groups)
        this.form = fb.group(
            {
                mgmtId: [data.content?.MgmtId, Validators.required]
            }, {
        });
    }
    
    
    resetAll() {
        this.treeControl = new NestedTreeControl<MGMTBranchNode>((node) => node.groups);
        this.dataSource = new MatTreeNestedDataSource<MGMTBranchNode>();
        this.funcGetManagementIdSelector();
    }

    public hasChild = (_: number, node: MGMTBranchNode) =>
        !!node.groups && node.groups.length > 0;


    public itemToggle(checked: boolean, node: MGMTBranchNode) {
        if (!this.manualItemSelected)
            this.manualItemSelected = true;
        if (checked) {
            this.selectedBranches.push(this.getFieldBranchId(node));
        } else {
            const branchId = this.getFieldBranchId(node);
            const index = this.selectedBranches.indexOf(branchId);
            if (this.selectedBranches.includes(branchId)) {
                this.selectedBranches.splice(index, 1);
            }
        }
        if (node.parent) {
            this.updateParentState(node.parent);
        }
    }

    public isAllBranchesNode(node: MGMTBranchNode): boolean {
        return node.groupName?.toLowerCase().includes('all branches') ?? false;
    }

    public toggleNodeDescendants(checked: boolean, node: MGMTBranchNode) {
        if (!this.manualItemSelected)
            this.manualItemSelected = true;
        const descendants = this.treeControl.getDescendants(node);
        for (const descendant of descendants) {
            this.processDescendantSelection(descendant, checked);
        }
        this.updateNodeSelectionState(node, descendants);
    }
    private processDescendantSelection(descendant: MGMTBranchNode, checked: boolean) {
        if (descendant.isSelectable) {
            descendant.selected = checked;
            const branchId = this.getFieldBranchId(descendant);
            if (checked) {
                if (!this.selectedBranches.includes(branchId)) {
                    this.selectedBranches.push(branchId);
                }
            } else {
                const index = this.selectedBranches.indexOf(branchId);
                if (index !== -1) {
                    this.selectedBranches.splice(index, 1);
                }
            }
        }
    }
    private updateNodeSelectionState(node: MGMTBranchNode, descendants: MGMTBranchNode[]) {
        const selectableDescendants = descendants.filter(d => d.isSelectable);
        const selectedCount = selectableDescendants.filter(d => d.selected).length;
        node.selected = selectableDescendants.length > 0 && selectedCount === selectableDescendants.length;
        node.indeterminate = selectedCount > 0 && selectedCount < selectableDescendants.length;
    }

    private updateParentState(node: MGMTBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        const selectableDescendants = descendants.filter(d => d.isSelectable);
        const selectedCount = selectableDescendants.filter(d => d.selected).length;
        node.selected = selectableDescendants.length > 0 && selectedCount === selectableDescendants.length;
        node.indeterminate = selectedCount > 0 && selectedCount < selectableDescendants.length;
        if (node.parent) {
            this.updateParentState(node.parent);
        }
    }

    public selectAll(selected: boolean) {
        this.manualItemSelected = false;
        this.selectAllCheckbox = selected;
        this.selectedBranches = [];
        
        for (const branchNode of this.treeControl.dataNodes) {
            this.processNode(branchNode);
            this.processDescendants(branchNode);
        }
    }

    private processNode(node: MGMTBranchNode): void {
        if (node.isSelectable) {
            node.selected = this.selectAllCheckbox;
            if (this.selectAllCheckbox) {
                this.selectedBranches.push(this.getFieldBranchId(node));
            }
        } else {
            node.selected = undefined;
        }
    }

    private processDescendants(branchNode: MGMTBranchNode): void {
        if (branchNode.groups) {
            const allDescendants = this.treeControl.getDescendants(branchNode);
            for (const node of allDescendants) {
                this.processNode(node);
            }
        }
    }

    private getFieldBranchId(node: MGMTBranchNode): string {
        const tokens = node.groupName.split(' - ');
        return tokens.at(-1) ?? '';
    }

    funcGetManagementIdSelector() {
        Utils.httpGetFieldManagementIdsFromOsh(
            this.http
            , this.baseUrl
            , 'FIELDBRANCH'
            , this.data.waveId
            , this
            , (tthis: OshAssignBranchPopupComponent, data: any) => {
                tthis.TREE_DATA = data;
                tthis.treeControl.dataNodes = tthis.TREE_DATA;
                tthis.dataSource.data = tthis.TREE_DATA;
                for (const key of Object.keys(this.dataSource.data)) {
                    this.setParent(this.dataSource.data[key], undefined);
                }
                if (data)
                    tthis.selectByDefault(tthis.dataSource.data, this.data.MgmtId)

            });
    }

    selectByDefault(objects: MGMTBranchNode[], mgmtId: string): void {
        for (const object of objects) {
            if (object.groupName.includes(mgmtId)) {
                object.selected = true;
                this.expandParentNode(object)
            }
            if (object.groups) {
                this.selectByDefault(object.groups, mgmtId);
            }
        }
    }

    private setParent(node: MGMTBranchNode, Parent: MGMTBranchNode | undefined) {
        if (node)
            node.parent = Parent;
        if (node.groups) {
            for (const childNode of node.groups) {
                this.setParent(childNode, node);
            }
        }
    }
    
    expandParentNode(node: MGMTBranchNode) {
        if (node.parent) {
            this.treeControl.expand(node.parent);
            this.expandParentNode(node.parent);
        }
    }

    public hideLeafNode(node: MGMTBranchNode): boolean {
        return new RegExp(this.searchString, 'i').test(node.groupName) === false;
    }


    public hideParentNode(node: MGMTBranchNode): boolean {
        if (
            !this.searchString || node.groupName.toLowerCase().includes(this.searchString.toLowerCase())) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.groupName
                        .toLowerCase()
                        .includes(this.searchString.toLowerCase())
            )
        ) {
            return false
        }

        return true
    }

    onSubmit() {
        Utils.httpAssignOshWaveBranchConfigurations(
            this.http
            , this.baseUrl
            , this.data.waveId
            , this.selectedBranches
            , this
            , (tthis: OshAssignBranchPopupComponent, data: any) => {
                if (data)
                    tthis.toastrService.success('Branches were assigned successfully!');
                else
                    tthis.toastrService.error('Branches could not be assigned. Please, contact with administrator');
                tthis.dialogRef.close();
            });
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    customSearchFn(term: string, item: any) {
        term = term.toLocaleLowerCase();
        return item.Address.toLocaleLowerCase().includes(term) ||
            item.BranchName.toLocaleLowerCase().includes(term) ||
            item.Country.toLocaleLowerCase().includes(term) ||
            item.Key.toLocaleLowerCase().includes(term) ||
            item.LocationForMap.toLocaleLowerCase().includes(term) ||
            item.MgmtId.toLocaleLowerCase().includes(term)
    }

}

